import { render, staticRenderFns } from "./CustomerModalBlock.vue?vue&type=template&id=f5f101be&scoped=true&"
import script from "./CustomerModalBlock.vue?vue&type=script&lang=ts&"
export * from "./CustomerModalBlock.vue?vue&type=script&lang=ts&"
import style0 from "./style.scss?vue&type=style&index=0&id=f5f101be&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5f101be",
  null
  
)

export default component.exports